// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AppearanceIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AppearanceIcon" ref={forwardedRef} {...props}>
      <path d="M11 4.5V2H9.5v2.5z" />
      <path d="M14.982 6.518 16.75 4.75l-1.06-1.06-1.768 1.767z" />
      <path d="M11 15.5V18H9.5v-2.5z" />
      <path d="M4.5 9.5H2V11h2.5z" />
      <path d="M18 9.5V11h-2.5V9.5z" />
      <path d="M6.518 5.518 4.75 3.75 3.69 4.81l1.767 1.768z" />
      <path d="m3.75 15.75 1.768-1.768 1.06 1.06-1.767 1.769z" />
      <path d="m13.982 14.982 1.768 1.768 1.06-1.06-1.767-1.768z" />
      <path d="M10 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-1.5a2.5 2.5 0 0 1 0-5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AppearanceIcon = /* @__PURE__ */ Object.assign(
  AppearanceIconComponent,
  { displayName: 'AppearanceIcon' },
);
